// Shared feed calculation logic for Dashboard and Feed screens
// Extracted from Feed.tsx for safe reuse

import type { MatrixData } from '../components/MatrixTable'

import { interpolateSfr } from './sfrMatrix'

export type DatabaseRow = {
  id: string
  lot: string
  stage: 'Active' | 'Inactive'
  date: string
  weight: string
  upVol: string
  mort: string
  fishStock: string
  do: string
}

export type WaterRow = {
  id: string
  date: string
  lot: string
  temperature: number | null
  ph: number | null
  dissolvedOxygen: number | null
  salinity: number | null
  notes: string
}

export type FeedKPI = {
  lot: string
  week: string
  weekDisplay: string
  biomassKg: number
  sfrPercent: number
  dailyFeedKg: number
  weeklyFeedKg: number
  sgr?: number
  fcr?: number
  temperatureWarning?: string
  temperatureStatus?: string
  clampedTemp?: number | null
  dataQuality: {
    hasWeight: boolean
    hasStock: boolean
    hasTemperature: boolean
    completeness: number
    missingData: string[]
  }
}

export function interpolateSFR(
  weight: number,
  temperature: number,
  options: {
    species?: string
    matrix?: MatrixData | null
  } = {}
) {
  return interpolateSfr(weight, temperature, options)
}
